"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableOkButton = enableOkButton;
exports.enableAllButtons = enableAllButtons;
function enableOkButton() {
    const okButton = document.querySelector('.primary');
    if (okButton != null) {
        okButton.disabled = false;
    }
}
function enableAllButtons() {
    const buttons = document.querySelectorAll('button');
    buttons.forEach((button) => {
        if (button.disabled) {
            button.disabled = false;
        }
    });
}
